import { symbolIndexWorkerClient } from '../worker/client.js';

export { indexOneSymbolFileForBuild } from './index-one-symbol-file-for-build.js';
export { registerSymbolIndexParent, registerSymbolIndexParentAsync } from './register-symbol-index-parent.js';

/**
 * Index a single file in the background worker thread.
 * Returns true when the requested file is ready for queries.
 */
export async function ensureSymbolIndexFileAsync(
  parentPath: string,
  filePath: string,
  opts?: { importDepth?: number },
): Promise<boolean> {
  return symbolIndexWorkerClient.ensureFile(parentPath, filePath, opts);
}

export { ensureSymbolIndexFileImpl } from './ensure-symbol-index-file-impl.js';
